import { ShieldAlert } from 'lucide-react';
import { useCurrentUser } from '../../hooks/useAuth';

/**
 * Visible red banner shown on every screen when the current session is
 * an emergency-mode session. Stays at the top of the viewport so the
 * operator cannot forget that audit logging is on.
 *
 * Deliberately uses the bold `danger` token (not the soft variant) so
 * the banner stays attention-grabbing across all themes — emergency
 * mode is the one place we want the visuals to feel slightly alarming.
 *
 * Per CLAUDE.md section 6.5: "Every screen shows a visible red banner:
 * Emergency mode active, all actions audited."
 */
export function EmergencyBanner() {
  const { data: user } = useCurrentUser();
  if (!user || user.login_method !== 'emergency') {
    return null;
  }
  return (
    <div
      role="alert"
      className="sticky top-0 z-50 flex w-full items-center justify-center gap-2 bg-danger px-4 py-2 text-center text-sm font-semibold text-danger-fg shadow-token-sm"
    >
      <ShieldAlert className="h-4 w-4" strokeWidth={2.5} />
      <span>Emergency mode active. All actions audited.</span>
    </div>
  );
}
